import httpRequest from "@/request/index";
const bigDataUrl = import.meta.env.VITE_APP_BIGDATA_API;
import { signData } from "@/utils/encrypt";
export const ApiHome = {
  // 获取banner
  apiGetBanner: () => {
    return httpRequest.request({
      url: `/api/zba/common/config/getByConfigCodes?configCodes=aigc_banner`,
      method: "GET",
    });
  },
  // 首页获取工作流
  apiGetMainList: (params: any) => {
    return httpRequest.request({
      url: `/api/zba/main/getList`,
      method: "GET",
      params,
    });
  },
  // 获取类型列表
  apiGetTypeList: () => {
    return httpRequest.request({
      url: `/api/zba/main/dict/data/type/work_flow_mark`,
      method: "GET",
    });
  },
  // 获取标签列表
  apiGetTagList: (params: any) => {
    return httpRequest.request({
      url: `/api/zba/main/getTagList`,
      method: "GET",
      params
    });
  },
  // 获取算力账户信息
  apiGetComputilityAccount: (params: any) => {
    return httpRequest.request({
      url: `api/zba/power/account`,
      method: "GET",
      params,
    });
  },
  // 获取算力记录列表
  apiGetComputilityList: (params: any) => {
    return httpRequest.request({
      url: `/api/zba/power`,
      method: "GET",
      params,
    });
  },
  // 功能算力消耗列表
  apiGetActiveList: () => {
    return httpRequest.request({
      url: `/api/zba/power/consumption/list`,
      method: "GET",
    });
  },
  // 获取智媒果支付套餐列表
  apiGetPackageList: () => {
    return httpRequest.request({
      url: `/api/zba/power/zmg/recharge/package/list`,
      method: "GET",
    });
  },
  // 创建充值订单并获取支付参数
  apiPostRechargeOrder: (data: any) => {
    const sign = signData(data);
    return httpRequest.request({
      url: `/api/zba/power/zmg/recharge/order?${sign}`,
      method: "post",
      data,
    });
  },
  // 查询订单状态
  apiGetOrderStatus: (orderNo: any) => {
    return httpRequest.request({
      url: `/api/zba/power/zmg/recharge/order?orderNo=${orderNo}`,
      method: "GET",
    });
  },
  // 智媒果获取消耗记录
  apiGetPowerImgList: (params: any) => {
    return httpRequest.request({
      url: `/api/zba/power/zmg/list`,
      method: "GET",
      params
    });
  },
  // 切换智媒果智媒豆
  apiPostAccountUpdate: (data: any) => {
    const sign = signData(data);
    return httpRequest.request({
      url: `/api/zba/power/account/update?${sign}`,
      method: "post",
      data,
    });
  },
};
